import { Component } from '@angular/core';

@Component({
    selector: 'app-reporting-skeleton',
    templateUrl: './reporting-skeleton.component.html',
    styleUrls: ['./reporting-skeleton.component.scss']
})
export class ReportingSkeletonComponent {
    // Helper arrays to generate repeated skeleton elements
    filterItems = [1, 2, 3, 4];
    statsRows = [1, 2, 3];
    metricCards = [1, 2, 3, 4, 5, 6];
    studentItems = [1, 2, 3];
    noActivityItems = [1, 2, 3, 4, 5];
    leaderboardRows = [1, 2, 3, 4];
    moduleRows = [1, 2, 3, 4, 5];
}
